// MODULES
import { I18n } from "core/I18n";
// =======
const XP = () => import("modules/xp/XP.vue");
export default [
    { path: "/", redirect: { name: 'game-1', params: { lang: I18n.locale } } },
    { path: "/:lang", name: "game-1", component: XP },
];
